export default {"src":"/_next/static/media/checkmark-icon-green.f8bf989b.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};